import {useEffect} from "react";
import {useFormContext} from "react-hook-form";

import {InputField} from "@/components/form/fields/InputField/InputField.tsx";
import {ServerErrors} from "@/lib/types/common.ts";
import {IntegrationFormData} from "@/lib/types/integrations.ts";
import {SetupInfo} from "@/pages/integrations/edit/subForms/components/SetupInfo.tsx";
import {IntegrationModuleInfo, IntegrationModules} from "@/pages/integrations/integrations.types.ts";

export type FormValuesKey = keyof IntegrationFormData;

interface VictorOpsFormProps {
  serverErrors?: ServerErrors;
}

export const VictorOpsForm = ({serverErrors}: VictorOpsFormProps) => {
  const {setError} = useFormContext();

  useEffect(() => {
    if (serverErrors) {
      Object.keys(serverErrors)
        .filter((k) => k !== "__all__")
        .forEach((key) => setError(`settings.${key}` as FormValuesKey, {message: serverErrors[key][0]}));
    }
  }, [setError, serverErrors]);

  return (
    <>
      <div className="row row-cols-2 mb-3">
        <div className="col-6 mb-3">
          <InputField
            name="settings.service_key"
            label="Service API Key"
            required={true}
            tooltip="Listed on the Settings / API page."
            maxLength={36}
            autoFocus={true}
          />
        </div>
        <div className="col-6 mb-3">
          <InputField
            name="settings.routing_key"
            label="Routing Key"
            required={false}
            tooltip="Routing key determines to which team alerts and incidents will be routed."
            maxLength={100}
          />
        </div>
      </div>
      <SetupInfo>
        <div className="p-2">
          First,{" "}
          <a target="_blank" href="https://www.splunk.com/en_us/software/splunk-on-call.html">
            login to your Splunk Account
          </a>
          , then click Settings &gt; Integrations. Next, locate "Uptime.com" and click "Enable Integration". Copy the
          "Service API Key" from the next screen.
        </div>
        <div className="p-2">
          Return to Uptime.com and paste the "Service API Key" copied previously into the Service API Key field, and
          Name the integration.
        </div>
        <div className="p-2">
          From your Splunk account, return to the Settings screen and click "Routing Key". Click Add Key and provide a
          routing key name. Copy this name, return to Uptime.com, and paste into the corresponding field.
        </div>
        <div className="p-2">
          <a target="_blank" href="https://support.uptime.com/hc/en-us/articles/115002536409-Configuring-VictorOps">
            View {IntegrationModuleInfo[IntegrationModules.SPLUNK].label} Support Article &rarr;
          </a>
        </div>
      </SetupInfo>
    </>
  );
};
